import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CRemuneracaoAdm extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	advanced = {
		factor: 0.25,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	years = [
		{
			text: '2019',
			expense: '0',
			selic: 1.27,
			balance: '0',
		},
		{
			text: '2020',
			expense: '0',
			selic: 1.22,
			balance: '0',
		},
		{
			text: '2021',
			expense: '0',
			selic: 1.2,
			balance: '0',
		},
		{
			text: '2022',
			expense: '0',
			selic: 1.16,
			balance: '0',
		},
		{
			text: '2023',
			expense: '0',
			selic: 1.05,
			balance: '0',
		},
	]

	updateSavings(item) {
		const expenseInt = parseFloat(
			item.expense.replaceAll('.', '').replaceAll(',', '.'),
		)

		item.balance = currencyFormat(
			this.parse(expenseInt * this.advanced.factor * item.selic),
		)
	}

	get totalBalance() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(
					item.balance.replaceAll('.', '').replaceAll(',', '.'),
				)
			)
		}, 0)

		this.$emit('savings', total)
		this.$emit('recuperate', total)

		return currencyFormat(total)
	}

	get totalExpense() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(
					item.expense.replaceAll('.', '').replaceAll(',', '.'),
				)
			)
		}, 0)

		return currencyFormat(total)
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(2))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.years = this.years
			found.factor = this.advanced.factor
		} else {
			this.calcsEach.unshift({
				id: this.id,
				years: this.years,
				factor: this.advanced.factor,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'Total Despesas',
						value: 'R$ ' + this.totalExpense,
					},
					{
						label: 'Economia Total',
						value: 'R$ ' + this.totalBalance,
					},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.totalBalance
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'Remuneração de Administradores e Conselheiros: Dedução da base de cálculo do IRPJ',
				color: this.color,
				columns: 2,
				rows: rows(),
				type: 'table',
				recuperate: this.totalBalance,
				savings: '0',
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.years = found.years
			this.advanced.factor = found.factor
		}
	}
}
